// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_9s-0";
export var optionCard = "_9s-1";